module.exports = __webpack_public_path__ + "assets/media/Ober_video.be88788d.mp4";